import * as React from "react";
import styles from "./AiStartupHeading.module.scss";
import topImage from "../../../images/topImage.png";
import bottomImg from "../../../images/bottomImg.png";
import middleImg from "../../../images/middleImg.png";
export function AiStartupHeading() {
  return (
    <div className={styles.heading}>
      <div className={styles.cardContainer}>
        <img
          loading="lazy"
          src={topImage}
          className={styles.cardImage}
          alt="Card content"
        />
      </div>
      <div className={styles.headingWrapper}>
        <span className={styles.headingText}>We are</span>
        <br />
        <span className={styles.highlightedText}>AN AI STARTUP</span>
      </div>

      <div className={styles.middleCardContainer}>
        <img
          loading="lazy"
          src={middleImg}
          className={styles.productImage}
          alt="Product showcase"
        />
      </div>

      <div className={styles.bottomCardContainer}>
        <img
          loading="lazy"
          src={bottomImg}
          className={styles.productImage}
          alt="Product showcase"
        />
      </div>
    </div>
  );
}
